/**
 * PageLoader Component
 *
 * Route-level Suspense fallback in App.tsx: shown while a lazy-loaded page's code downloads (first
 * visit only — the chunk is cached afterwards). It draws nothing itself; it raises the same global
 * loading overlay every page uses, so the user sees ONE loader from route change until the page's
 * data is ready (the page registers its own loading as it mounts, in the same commit).
 */

import { usePageLoading } from '@/hooks/usePageLoading';

interface PageLoaderProps {
  /** Optional message on the overlay */
  label?: string;
}

export function PageLoader({ label = 'Loading…' }: PageLoaderProps) {
  usePageLoading(true, { message: label });
  return null;
}

export default PageLoader;
